import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import Select from '@jetbrains/ring-ui/components/select/select'
import classNames from 'classnames'
import {useCallback, useMemo} from 'react'

import styles from './ParameterValuesSelect.css'

type Props = {
  className?: string
  parameterName: string
  data: ReadonlyArray<{label?: string; value: string}>
  selected: ReadonlyArray<string>
  onChange?: (name: string, values: string[]) => void
}

function ParameterValuesSelect({className, parameterName, data, selected, onChange}: Props) {
  const options = useMemo(
    () =>
      data.map(({label, value}, index) => ({
        label: label ?? value,
        key: index,
        value,
        disabled: selected.length === 1 ? selected[0] === value : false,
      })),
    [data, selected],
  )
  const selectedOptions = options.filter(({value}) => selected.includes(value))
  const onSelectChange = useCallback(
    (newSelected: SelectItem<{value: string}>[] | null) => {
      if (onChange != null) {
        onChange(parameterName, newSelected?.map(({value}) => value) ?? [])
      }
    },
    [parameterName, onChange],
  )

  return (
    <Select
      className={classNames(className, styles.select)}
      type={Select.Type.INLINE}
      data={options}
      selected={selectedOptions}
      onChange={onSelectChange}
      multiple
      filter
      clear
    />
  )
}

export default ParameterValuesSelect
